import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'ArticleHeroImage',
})(({ breakpoints, spacing, brandColors, aspectRatio, typography }) => ({
  featuredArticleContainer: {
    position: 'relative',
    borderRadius: typography.pxToRem(16),
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    aspectRatio: aspectRatio['4/3'],
    width: '100%',
    height: 'auto',
    '& > img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.3s ease-in-out',
      zIndex: 0,
    },
    '&:hover > img': {
      transform: 'scale(1.1)',
    },
    [breakpoints.up('sm')]: {
      aspectRatio: aspectRatio['16/9'],
    },
  },
  featuredArticleTextContainer: {
    position: 'absolute',
    bottom: 0,
    padding: spacing(2),
  },
  titleContainer: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    textDecoration: 'none',
  },
  heading: {
    color: brandColors.heroYellow,
    '& > a': {
      textDecoration: 'inherit',
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  articleInfo: {
    display: 'block',
    margin: `${spacing(0)} 0 ${spacing(1)} 0`,
  },
  gradientWrapper: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, #000 100%)',
    [breakpoints.up('sm')]: {
      borderRadius: typography.pxToRem(16),
    },
  },
}));

export default useStyles;
